import { useState, useEffect } from "react";

const EditModal = ({ fields, initialValues, onSubmit, title, onClose }) => {
  const [values, setValues] = useState(initialValues || {});

  useEffect(() => {
    setValues(initialValues || {});
  }, [initialValues]);

  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(values);
  };

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">{title}</p>
          <button className="delete" aria-label="close" onClick={onClose}></button>
        </header>
        <section className="modal-card-body">
          <form onSubmit={handleSubmit}>
            {fields.map(field => (
              <div className="field" key={field.name}>
                <label className="label">{field.label}</label>
                <div className="control">
                  {field.type === "custom" && field.component ? (
                    <field.component
                      inicial={values[field.name] || {}}
                      onChange={(newValue) => handleChange(field.name, newValue)}
                      {...(field.componentProps || {})}
                    />
                  ) : field.type === "textarea" ? (
                    <textarea
                      className="textarea"
                      value={values[field.name] || ""}
                      onChange={e => handleChange(field.name, e.target.value)}
                      required={field.required}
                    />
                  ) : field.type === "select" ? (
                    <select
                      className="input"
                      value={values[field.name] || ""}
                      onChange={e => handleChange(field.name, e.target.value)}
                      required={field.required}
                    >
                      <option value="">Seleccionar</option>
                      {field.options && field.options.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      className="input"
                      type={field.type}
                      value={values[field.name] || ""}
                      onChange={e => handleChange(field.name, e.target.value)}
                      required={field.required}
                    />
                  )}
                </div>
              </div>
            ))}
            <div className="mt-4">
              <button type="submit" className="button is-success mr-2">Guardar</button>
              <button type="button" className="button" onClick={onClose}>Cancelar</button>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
};

export default EditModal;